import React from 'react';

/**
 * Times/Close icon component - Custom 15x15px icon for UI close buttons.
 *
 * Usage: Use this icon for close buttons in UI components like modals, toasts, sidebars,
 * and navigation. This is the original custom icon used throughout the application.
 *
 * For content components that were migrated from styled-icons, use components/icons/Times.tsx (TimesIcon) instead.
 */
const SvgComponent = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width='15px' height='15px' viewBox='0 0 15 15' version='1.1' {...props}>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-302.000000, -18.000000)' fill='currentColor'>
        <g transform='translate(302.000000, 18.000000)'>
          <path d='M7.5,5.41522791 L12.0331524,0.579865364 C12.3077536,0.286957429 12.7165503,0.24816296 12.946282,0.493210121 L13.9861449,1.60239723 C14.2158766,1.84744439 14.1795068,2.28349422 13.9049056,2.57640216 L9.37175324,7.41176471 L13.9049056,12.2471273 C14.1795068,12.5400352 14.2158766,12.976085 13.9861449,13.2211322 L12.946282,14.3303193 C12.7165503,14.5753665 12.3077536,14.536572 12.0331524,14.243664 L7.5,9.4083015 L2.96684761,14.243664 C2.69224642,14.536572 2.2834497,14.5753665 2.05371799,14.3303193 L1.01385508,13.2211322 C0.784123363,12.976085 0.820493178,12.5400352 1.09509437,12.2471273 L5.62824676,7.41176471 L1.09509437,2.57640216 C0.820493178,2.28349422 0.784123363,1.84744439 1.01385508,1.60239723 L2.05371799,0.493210121 C2.2834497,0.24816296 2.69224642,0.286957429 2.96684761,0.579865364 L7.5,5.41522791 Z'></path>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgComponent;
